export const virtualGridProps = {
  store: Object,
  containerElement: {
    type: String | Object,
    default: 'div',
  },
  innerElement: {
    type: [String, Object],
    default: 'div',
  },
  estimatedRowHeight: {
    type: Number,
    default: 50
  },
  width: Number,
  height: Number,
  columnTotalWidth: Number,
  rowTotalHeight: Number,
  rowHeight: Number,
  type: String,
  tableWidth: Number,
  columns: Array,
  fixedRowsTop: Number,
  tableDatas: Array,
  vScrollbarSize: Number,
  hScrollbarSize: Number,
  highlightCurrentRow: {
    type: Boolean,
    default: false
  },
  enableDynamicHeight: {
    type: Boolean,
    default: false
  },
  scrollbarStyle: Object,
  direction: {
    type: String,
    default: 'ltr'
  },
  scrollbarAlwaysOn: {
    type: Boolean,
    default: true
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/props/virtual-grid.js